import configdata from "../../config.json";
import { factorySliceAction } from "./FactorySlice";
import { getApi } from "../BaseApi";
import { getOnlyValueFromSelectObject } from "../UseAbleFun";
import { appLevelSliceActions } from "../AppLevelApi/AppLevelSlice";
export const getAllFactoryItems = () => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi("get", `${configdata.SERVER_URL}/api/factories`);
    dispatch(appLevelSliceActions.setLoadingState());
    dispatch(factorySliceAction.getAllFactory(res.data.factories));
  };
};
export const createFactoryItem = (data) => {
  return async (dispatch) => {
    const { form } = getOnlyValueFromSelectObject(data);
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "post",
      `${configdata.SERVER_URL}/api/factories/store`,
      form
    );

    if (res?.error) {
      if (res?.erroType === "single") {
        dispatch(
          appLevelSliceActions.setError({ msg: res.message, isError: true })
        );
      } else {
        dispatch(
          factorySliceAction.setErrorData({
            message: res.message,
            isError: true,
          })
        );
      }

      dispatch(appLevelSliceActions.setLoadingState());
      return;
    }
    dispatch(
      factorySliceAction.setErrorData({
        message: {},
        isError: false,
      })
    );
    dispatch(appLevelSliceActions.setLoadingState());
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(factorySliceAction.setInitialData());

    dispatch(getAllFactoryItems());
  };
};
export const getDataForEdit = (id) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "get",
      `${configdata.SERVER_URL}/api/factories/edit/${id}`
    );

    const data = { ...res.data.factory[0] };
    dispatch(appLevelSliceActions.setLoadingState());
    data.status = {
      value: `${data.status}`,
      label: data.status === "active" ? "Active" : "Deactive",
      type: "status",
    };
    dispatch(factorySliceAction.getFactoryDataEdit(data));
  };
};

export const updateFactoryItem = (data) => {
  const { form } = getOnlyValueFromSelectObject(data);
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const resData = await getApi(
      "post",
      `${configdata.SERVER_URL}/api/factories/update/${data.id}`,
      form
    );
    if (resData?.error) {
      if (resData?.errorType === "single") {
        dispatch(
          appLevelSliceActions.setError({ msg: resData.message, isError: true })
        );
      } else {
        dispatch(
          factorySliceAction.setErrorData({
            message: resData.message,
            isError: true,
          })
        );
      }

      dispatch(appLevelSliceActions.setLoadingState());
      return;
    }
    dispatch(
      factorySliceAction.setErrorData({
        message: {},
        isError: false,
      })
    );
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(factorySliceAction.setInitialData());
    dispatch(appLevelSliceActions.setLoadingState());
    dispatch(getAllFactoryItems());
  };
};

export const deleteFactoryItem = (id) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    await getApi("get", `${configdata.SERVER_URL}/api/factories/delete/${id}`);
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(appLevelSliceActions.setLoadingState());
  };
};
